"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsProvider = void 0;
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const react_1 = tslib_1.__importStar(require("react"));
function AnalyticsProvider({ children, context, }) {
    const analytics = (0, react_1.useMemo)(() => {
        const handlers = [];
        return {
            setUserId(userId) {
                for (const handler of handlers) {
                    try {
                        handler.setUserId?.(userId);
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            },
            trackEvent(event) {
                for (const handler of handlers) {
                    try {
                        handler.trackEvent?.((0, lodash_1.cloneDeep)(event));
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            },
            trackPage(data) {
                for (const handler of handlers) {
                    try {
                        handler.trackPage?.(data);
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            },
            addHandler(handler) {
                handlers.push(handler);
            },
            removeHandler(handler) {
                const index = handlers.indexOf(handler);
                if (index >= 0) {
                    handlers.splice(index, 1);
                    return true;
                }
                return false;
            },
        };
    }, []);
    return react_1.default.createElement(context.Provider, { value: analytics }, children);
}
exports.AnalyticsProvider = AnalyticsProvider;
//# sourceMappingURL=index.js.map